import './styles/main.css'
import { initNavbar } from './components/navbar'
import { initWaitlistForms } from './components/waitlist-form'
import { initFaqAccordion } from './components/faq-accordion'
import { initComparisonSection } from './components/comparison-section'
import { initHeroViewport } from './components/hero-viewport'
import { initDotBackground } from './components/dot-background'

// Initialize all components when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  initDotBackground()
  initNavbar()
  initWaitlistForms()
  initFaqAccordion()
  initHeroViewport()
  initComparisonSection()

  // Mobile hero parallax — dwarf scrolls slower than text for depth effect
  if (window.innerWidth < 1024) {
    const hero = document.querySelector('.hero-mobile-video') as HTMLElement
    if (hero) {
      window.addEventListener('scroll', () => {
        const scrollY = window.scrollY
        hero.style.transform = `translateY(calc(-50% + ${scrollY * 0.15}px))`
      }, { passive: true })
    }
  }
})
